import type { ChangeEvent } from 'react';
import { lower, upper } from '../domain/text.ts';

type TextElement = HTMLInputElement | HTMLTextAreaElement;

/**
 * Convierte el valor escrito a mayúsculas antes de entregarlo al manejador, conservando la posición
 * del cursor. El valor queda en mayúsculas en el estado (no es solo un efecto visual de CSS).
 */
export function uppercaseChange<E extends TextElement>(handler?: (event: ChangeEvent<E>) => void) {
  return convertChange(upper, handler);
}

/** Lo mismo en minúsculas, para el correo. */
export function lowercaseChange<E extends TextElement>(handler?: (event: ChangeEvent<E>) => void) {
  return convertChange(lower, handler);
}

/** Filtra el valor escrito con `convert` (por ejemplo, solo números) antes de entregarlo al manejador. */
export function convertChange<E extends TextElement>(
  convert: (value: string) => string,
  handler?: (event: ChangeEvent<E>) => void,
) {
  return (event: ChangeEvent<E>) => {
    const element = event.target;
    const next = convert(element.value);
    if (next !== element.value) {
      const { selectionStart, selectionEnd } = element;
      const grew = next.length - element.value.length; // "ß" → "SS"
      element.value = next;
      if (selectionStart !== null && selectionEnd !== null) {
        try {
          element.setSelectionRange(selectionStart + grew, selectionEnd + grew);
        } catch {
          // Algunos tipos de input no admiten selección: el valor ya quedó convertido.
        }
      }
    }
    handler?.(event);
  };
}
